// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.drag-handle[data-v-36c1b775] {\n    cursor: move;\n    cursor: grab;\n}\n", ""]);
// Exports
module.exports = exports;
